import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const fmtPreferred = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  return isNaN(d) ? v : d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
};

export default function QuickRequestsPanel() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/quick-requests")
      .then((r) => setRows(r.data))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail) || e.message));
  }, []);

  return (
    <div className="soft-card p-6" data-testid="quick-requests-panel">
      <div className="font-display text-lg font-bold text-slate-900">Quick requests ({rows.length})</div>
      <p className="text-sm text-slate-500 mt-1">Sent from the landing page without login. Reply on WhatsApp within 2 hours.</p>
      <div className="mt-5 space-y-3">
        {rows.length === 0 && <div className="text-sm text-slate-500" data-testid="quick-requests-empty">No quick requests yet.</div>}
        {rows.map((r) => (
          <div key={r.id} data-testid={`quick-request-${r.id}`} className="border border-slate-200 rounded-xl p-4 text-slate-900">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="font-semibold">{r.name}</div>
              <div className="text-xs text-slate-500">Received {new Date(r.created_at).toLocaleString("en-IN")}</div>
            </div>
            <a
              href={`https://wa.me/${r.phone.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`quick-request-wa-${r.id}`}
              className="text-sm font-semibold text-green-700 underline"
            >
              {r.phone}
            </a>
            <p className="text-sm text-slate-700 mt-2 whitespace-pre-wrap">{r.issue_description}</p>
            <div className="text-xs text-slate-500 mt-2">Preferred: {fmtPreferred(r.preferred_time)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
